import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";
import {getItemName} from "../../../shared/utils/basic";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

const field = (title, key) => ({
    title,
    dataIndex: 'logString',
    render: (logString, record) => parseLogData(logString, record)[key],
});

const triggerTimeColumn = {
    title: '트리거 시간',
    dataIndex: 'logString',
    render: (logString, record) => {
        const {triggerTime} = parseLogData(logString, record);
        return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
    },
};

// RQDiceRollLog: Spend_DiceRace_Cost
export const getDiceRollLogColumns = () => [
    field('로그 타입', 'logType'),
    field('맵 테이블', 'mapTableIndex'),
    field('주사위 비용', 'diceCost'),
    field('배수', 'multiple'),
    {
        title: '주사위 눈',
        dataIndex: 'logString',
        render: (logString, record) => parseLogData(logString, record).diceNums?.join(', '),
    },
    field('시작 타일', 'startTileNum'),
    field('도착 타일', 'endTileNum'),
    triggerTimeColumn,
];

// RQDiceRewardLog: Gain_DiceRace_TileReward
export const getDiceRewardLogColumns = (krTextData, currentUser) => [
    field('로그 타입', 'logType'),
    {
        title: '획득 아이템',
        dataIndex: 'logString',
        render: (logString, record) => (parseLogData(logString, record).itemInfo || [])
            .map(({ItemType, ItemIndex, Count}) =>
                `${getItemName(krTextData[currentUser.target], ItemIndex, ItemType)}(${ItemIndex}) x ${Count}`)
            .join(', '),
        width: '40%',
    },
    triggerTimeColumn,
];
